import { iamEmailManager, iamLoginMethodManager } from "@/manager";
import { joinWaitingQueue } from "@/services/join-waiting-queue";

export const useAPIJoinWaitingQueue = () => {
  const handleAPIJoinWaitingQueue = async () => {
    await joinWaitingQueue({
      email: iamEmailManager.get(),
      loginMethod: iamLoginMethodManager.get(),
    });
  };

  return {
    handleAPIJoinWaitingQueue,
  };
};
